export * from './api';
export type {
  AddOfferAlternativeRequestBody,
  SellerOfferAlternatives,
  UpdateOfferAlternativeRequestBody,
} from './codegen/__generated__/api.generated';
